import React, { memo } from 'react'
import { Tooltip, TooltipProps } from 'react-leaflet'
import styled from 'styled-components'
import { Feature } from 'geojson'
import { GeoJSON } from 'react-leaflet'
import isEqual from 'react-fast-compare'
import { geoJSONPolylabelPositions, GeoJSONGeometry } from '../../../utils/cartography'
import { theme } from '../../../config'

export type Props = TooltipProps & {
  label: string
  feature: Feature<GeoJSONGeometry>
}

export const TransparentTooltip = styled(Tooltip)`
  && {
    background-color: transparent;
    border: none;
    box-shadow: none;
    color: ${theme.colors.white};
    font-weight: 700;
    text-shadow: ${theme.colors.black} 0px 0px 2px;
  }
`

export const FeatureLabel = memo<Props>(({ label, feature, ...props }) => {
  const positions = geoJSONPolylabelPositions(feature.geometry)
  const data = { type: 'Polygon', coordinates: [positions] } as const

  return positions.length ? (
    <GeoJSON data={data}>
      {positions.map((position, index) => (
        <TransparentTooltip key={index} permanent position={position} direction='center' {...props}>
          <span>{label}</span>
        </TransparentTooltip>
      ))}
    </GeoJSON>
  ) : null
}, isEqual)
